import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    description: {
        color: 'rgb(255, 255, 255)',
        textAlign: 'left',
    },
    errorAlert: {
        maxWidth: 800,
        '& .MuiAlert-icon': {
            display: 'flex',
            alignItems: 'center',
        },
        '& .MuiAlert-message': {
            width: '100%',
        }
    },
    alertWrap: {
        display: 'flex',
        alignItems: 'center',
    },
    message: {
        padding: theme.spacing(1, 6, 1, 2),
        flexGrow: 1,
    },
    action: {
        padding: theme.spacing(1),
        display: 'flex',
        alignItems: 'center',
    },
    actionBtn: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#000000',
        borderRadius: 8,
        padding: theme.spacing(1.5, 2),
        cursor: 'pointer',
        minWidth: 100,
    },
    actionClose: {
        marginRight: theme.spacing(-2),
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        fontSize: '32px',
        minWidth: 40,
    },
}));

